const Constants = {
  ActionTypes: {
    CHANGE_EVENT: "change",
    TSS_CONNECTION_FAILED: "tss-connection-failed",

    LOADING_ALL_FORM_B_RESTRICTIONS: "loading-all-form-b-restrictions",
    LOADED_ALL_FORM_B_RESTRICTIONS: "loaded-all-form-b-restrictions",

    OPEN_FORM_B_RESTRICTION: "open-form-b",
    SUBMIT_FORM_B_RESTRICTION: "submit-form-b",
    PERSISTED_FORM_B_RESTRICTION: "persisted-form-b",
    PERSIST_FAILED_FORM_B_RESTRICTION: "persist-failed-form-b",
    UPDATED_FORM_B_RESTRICTION: "updated-form-b-restriction",
    DELETE_FORM_B_REQUEST: "delete_form_b_request",
    REJECTED_FORM_B_RESTRICTION: "rejected-form-b",
    VOID_FORM_B_RESTRICTION: "void-form-b",
    SUBDIVISION_RECALCULATE_SUCCESS: "subdivision-success",
    SUBDIVISION_RECALCULATE_FAILED: "subdivision-failed",

    EFFECTIVE_DATE_CHANGED: "effective-date-changed",
    EXPIRE_DATE_CHANGED: "expire-date-changed",
    ESTIMATED_REMOVAL_DATE_CHANGED: "estimated-removal-date-changed",
    WORK_END_DATE_CHANGED: "work-end-date-changed",
    WORK_START_DATE_CHANGED: "work-start-date-changed",

    FORM_FIELD_BLURRED: "form-field-blurred",
    FORM_FIELD_CHANGED: "form-field-changed",
    FORM_FIELD_INVALID: "form-field-invalid,",
    FORM_FIELD_VALID: "form-field-valid",
    CLIENT_FIELD_INVALID: "client-field-invalid",
    CLIENT_FIELD_VALID: "client-field-valid",
    DATE_FORM_FIELD_VALID: "date-form-field-valid",
    TRACK_SELECTION_CHANGED: "track-selection-changed",
    SERVER_ACTION_FAILED: "server-action-failed",
    RESET_FORM_B_RESTRICTION: "reset-form-b",
    ADD_BORDERING_ROW: "add-bordering-row",
    DELETE_BORDERING_ROW: "delete-bordering-row",
    SELECT_CHANGED: "select-changed",
    REASON_CHANGED: "reason-changed",
    NO_FLAGS_CHANGED: "no-flags-changed",
    SHOW_DEFAULT_TRACKS_VALUE_CHANGED: "show-default-tracks-value-changed",
    VALIDATE_FORM_B_RESTRICTION: "validate-form-b-restriction",
    SUPERVISOR_AUTH_SET: "super-auth-set",
    CONFIRM_SET: "confirm_set",
    SLODT_SET: "sloDt_set",
    REQUEST_RADIO_CHANGED: "request-radio-changed",
    //SORT_APPLIED: 'sort-applied',
    //DEFAULT_SORT_APPLIED: 'default-sort-applied',
    //FILTER_APPLIED: 'filter-applied',
    TOGGLE_SHOW_FORM_C_FROM_LOCATIONS: "toggle-show-form-c-from-locations",
    TOGGLE_SHOW_FORM_C_TO_LOCATIONS: "toggle-show-form-c-to-locations",
    TOGGLE_SHOW_FORM_TCM_FROM_LOCATIONS: "toggle-show-form-tcm-from-locations",
    TOGGLE_SHOW_FORM_TCM_TO_LOCATIONS: "toggle-show-form-tcm-to-locations",
    FORM_C_SUBDIVISION_SELECTED: "form-c-subdivision-selected",
    FORM_C_DIVISION_SELECTED: "form-c-division-selected",
    FORM_C_LOCATION_SELECTED: "form-c-from-location-selected",
    FORM_TCM_LOCATION_SELECTED: "form-tcm-from-location-selected",
    FORM_C_TEXT_CHANGED: "form-c-text-changed",
    TCM_TEXT_CHANGED: "tcm-text-changed",
    TOGGLE_SHOW_SUB_DROPDOWN: "show-sub-dropdown",
    FORMCDT_SET: "formCDt_set",
    FORMTCMDT_SET: "formTCMDt_set",
    PATTERN_LIST_LOADED: "pattern-list-loaded",
    TCM_COND_PERM_CHANGED: "tcm-cond-perm-changed",
    TCM_PRINT_CHANGE: "tcm-print-change",
    TOGGLE_HIDE_FORM: "toggle-hide-form",

    COMMENT_MODAL_CLOSED: "comment-modal-closed",
    COMMENT_MODAL_OPENED: "comment-modal-opened",
    BORDERING_FLAG_MODAL_CLOSED: "bordering-flag-modal-closed",
    BORDERING_FLAG_VALIDATION_COMPLETE: "bordering-flag-validation-complete",

    USER_CHANGED: "user-changed",
    TAB_CHANGED: "tab-changed",
    REASON_CODES_LOADED: "reason-codes-loaded",
    OVERRIDE_REASON_CODES_LOADED: "override-reason-codes-loaded",

    OPEN_FORM_B_REQUEST: "open-form-b-request",
    OPENING_RESTRICTION: "opening-restriction",
    OPEN_FORM_A_RESTRICTION: "open-form-a-restriction",
    OPEN_FORM_A_REQUEST: "open-form-a-request",
    OPEN_FORM_C_RESTRICTION: "open-form-c-restriction",
    OPEN_TCM_RESTRICTION: "open-tcm-restriction",
    TOGGLE_MODIFY_REQUEST_MODE: "toggle-modify-request-mode",
    RESET_REQUEST_INFO: "reset-request-info",

    TERRITORY_LIST_LOADED: "territory-list-loaded",
    TERRITORY_CHANGED: "territory-changed",
    TERRITORY_DETAIL_LOADING: "territory-list-loading",
    TERRITORY_DETAILS_LOADED: "territory-details-loaded",
    TERRITORY_LIST_FAILED_LOAD: "territory-list-failed-load",
    TERRITORY_DETAIL_FAILED_LOAD: "territory-detail-failed-load",

    SUBDIVISION_LIST_LOADED: "subdivision-list-loaded",
    DIVISION_LIST_LOADED: "division-list-loaded",
    SUBDIVISION_LOCATIONS_LOADING: "subdivision-locations-loading",
    SUBDIVISION_LOCATIONS_LOADED: "subdivision-locations-loaded",
    PTC_SUBDIVISION_LIST_LOADED: "ptc-subdivision-list-loaded",
    SUBDIVISION_CHANGED: "subdivision-changed",
    SUBDIVISION_DETAILS_LOADED: "subdivision-details-loaded",
    SUBDIVISION_LIST_FAILED_LOAD: "subdivision-list-failed_load",
    SUBDIVISION_DETAIL_FAILED_LOAD: "subdivision-detail-failed_load",
    COMPARE_SUBDIVISION_CHANGED: "compare-subdivision-changed",
    COMPARE_GIS_ENVIRONMENT_CHANGED: "compare-gisEnv-changed",
    FORM_C_SUBDIVISION_DETAILS_LOADED: "form-c-subdivision-details-loaded",

    REQUEST_LIST_LOADED: "request-list-loaded",
    ISSUED_LIST_LOADED: "issued-list-loaded",
    ACTIVE_LIST_LOADED: "active-list-loaded",
    SUB_ACTIVE_LIST_LOADED: "sub-active-list-loaded",
    SUB_RECENT_LIST_LOADED: "sub-recent-list-loaded",
    HISTORY_LIST_LOADED: "history-list-loaded",
    REQUEST_LIST_LOADING: "request-list-loading",
    ISSUED_LIST_LOADING: "issued-list-loading",
    ACTIVE_LIST_LOADING: "active-list-loading",
    SUB_ACTIVE_LIST_LOADING: "active-list-loading",
    SUB_RECENT_LIST_LOADING: "recent-list-loading,",
    HISTORY_LIST_LOADING: "history-list-loading",
    LIST_FAILED_LOADING: "list-failed-loading",
    RECENT_LIST_SORT_CHANGED: "recent-list-sort-changed",

    SHOW_REQUEST_LIST: "show-request-list",
    REQUEST_LIST_LOAD_COMPLETE: "request-list-load-complete",
    SHOW_REQUEST_HISTORY: "show-request-history",
    REQUEST_HISTORY_LOAD_COMPLETE: "request-history-load-complete",

    GO_TO_PREVIOUS_TAB: "go-to-previous-tab",
    BATCH_SELECT: "batch-select",
    CHANGE_BATCH_MODE: "change-batch-mode",
    NEW_BATCH_INDEX: "new-batch-index",
    BATCH_VALIDATION_SUCCESSFUL: "batch-validation-successful",
    SELECT_BATCH_TYPE: "select-batch-type",
    START_BATCH: "start-batch",
    BATCH_SUBMIT_SUCCESSFUL: "batch-submit-successful",
    PERSIST_FAILED_BATCH: "persist-failed-batch",
    CENTER_ZOOM_CHANGED: "center-zoom-changed",
    GIS_ENVIRONMENT_CHANGED: "gis-environment-changed",
    RELOAD_ENTERED_TEXT: "reload-entered-text",

    TOGGLE_COLLAPSE: "toggle-collapse",
    BACKGROUND_RELOAD: "background-reload",
    REQUEST_LIST_STORE: "request-list-store",
    ISSUED_LIST_STORE: "issued-list-store",

    SET_USER_ROLE: "set-user-role",
    PRINT_LATA_CHANGED: "print-lata-changed",

    SET_NAVIGATE: "set-navigate",
    SET_EXCLUDE: "set-exclude",
    SET_SELECT: "set-select",
    SET_DESELECT: "set-deselect",
    GUIDS_SELECTED: "guids-selected",
    HIDE_SCHEMATIC: "hide-schematic",
    SHOW_SCHEMATIC: "show-schematic",
    SCHEMATIC_SUB_FAILED_LOAD: "schematic-sub-failed-load",
    DEFAULT_TRACK_LIST_LOADED: "default-track-list-loaded",
    SCHEMATIC_SUB_LOADED: "schematic-sub-loaded",
    EXCLUSION_LIST_UPDATED: "exclusion-list-updated",
    POLL_SUCCESSFUL: "poll-successful",

    UPDATE_SCHEMATIC_FROM_TEXT: "update-schematic-from-text",
    UPDATE_TEXT_FROM_SCHEMATIC: "update-text-from-schematic",
    SCHEMATIC_UPDATE_COMPLETE: "schematic-update-completed",
    SCHEMATIC_CALCULATED_GUIDS: "schematic-calculated-guids",
    SCHEMATIC_CLICKED: "schematic-clicked",
    TRACK_LIST_UPDATED: "track-list-updated",
    RETRIEVED_DEFAULT_TRACKS: "retrieved-default-tracks",

    //Server Guid Calculation
    SERVER_CALCULATED_GUIDS: "server-calculated-guids",
    SERVER_CALCULATING_GUIDS: "server-calculating-guids",
    SERVER_GUID_ERROR: "server-guid-error",

    DUMP_ERRORS: "dump-errors",
    ERROR_OCCURRED: "error-occurred",

    //these actions are used for schematic updates, not the flux cycle
    ADD_GUID: "add-guid",
    REMOVE_GUID: "remove-guid",
    FORM_UPDATED: "form-updated",
    HIGHLIGHT_FROM_GUIDS: "highlight-from-guids",
    OPEN_ITEM: "open-item",

    RESET_COMPARE_DETAILS: "reset-compare-details",
    RESET_RUN_COMPARE_DETAILS: "reset-run-compare-details",
    TOGGLE_COMPARE_LISTS: "toggle-compare-lists",

    INITIALIZE_POLL: "initialize-poll",
    POLL_NEW_ID: "poll-new-id",
    REMOVE_POLL_ID: "remove-poll-id",
    START_POLL: "start-poll",
    STOP_POLL: "stop-poll",
    KILL_POLLING_DUE_TO_ERROR: "kill-polling-due-to-error",

    SUBMITTING_TO_SERVER: "submitting-to-server",
    SUBMIT_T0_SERVER_200: "submit-to-server-200", //200 response
    SUBMIT_TO_SERVER_404_500: "submit-to-server-404_500", //404 or 500
    SUBMIT_TO_SERVER_SUCCESSFUL: "submit-to-server-successful", //200 and data.success === true
    SUBMIT_TO_SERVER_FAILED: "submit-to-server-failed", //200 but got data.success === false
    NO_TSS_RESPONSE_ON_POLL: "poll-failed", //poll transport worked but didnt' get request back
    MF_ERROR_RETURNED: "mf-error-returned", //the poller got the request back but the MF attached some error to it

    SUBMIT_TO_SERVER_VALIDATE_MP_FINISHED:
      "submit-to-server-validate-mp-finished", //Clears the blocking after MP validation runs

    SHOW_MODAL_ERROR: "show-modal-error",
    HIDE_MODAL_ERROR: "hide-modal-error",

    SHOW_BANNER: "show-banner",
    SHOW_OUTAGE: "show-outage",
    END_OUTAGE: "end-outage",
    LOAD_OUTAGE_LIST: "load-outage-list",
    SET_OUTAGE_LIST: "set-outage-list",
    ERROR_OUTAGE_LIST: "error-outage-list",
    OUTAGE_FROM_SERVER: "outage-from-server",

    SET_ADMIN_ITEM_TYPE: "set-admin-item-type",
    LOAD_ADMIN_ITEMS_STARTED: "load-admin-items-started",
    LOAD_ADMIN_ITEMS_DONE: "load-admin-items-done",
    LOAD_ADMIN_ITEMS_ERROR: "load-admin-items-error",
    CELL_UPDATED: "cell-updated",
    NEW_OVERRIDE_SUBMITTED: "new-override-submitted",
    EXISTING_OVERRIDE_EXPIRED: "existing-override-expired",
    NEW_ADMIN_ROW_ENTERED: "new-admin-row-entered",
    ADMIN_ITEM_SUBMIT_ERROR: "admin-item-submit-error",

    //SLS
    LOAD_SLS_ITEMS_STARTED: "load-sls-items-started",
    LOAD_SLS_ITEMS_DONE: "load-sls-items-done",
    LOAD_SLS_ITEMS_ERROR: "load-sls-items-error",
    LOAD_SLS_ITEM_STARTED: "load-sls-item-started",
    LOAD_SLS_ITEM_DONE: "load-sls-item-done",
    LOAD_SLS_ITEM_ERROR: "load-sls-item-error",
    SLS_ITEM_UPDATING: "sls-item-updating",
    SLS_ITEM_UPDATE_SUCCESS: "sls-item-update-success",
    SLS_ITEM_UPDATE_FAIL: "sls-item-update-fail",
    SLS_ITEM_CLEAR: "sls-item-clear",
    CHANGE_SLS_SEARCH_BY: "change-sls-search-by",
    FILTER_SLS_ITEMS: "filter-sls-items",
    LOAD_RESEND_ITEM: "load-resend-item",
    RESEND_ITEM_CLEAR: "resend-item-close",
    SLS_RESEND_FAIL: "sls-resend-failed",
    SLS_RESEND_SUCCESS: "sls-resend-success",

    //WebSockets
    OVERRIDE_GRANTED: "override-granted",
    OVERRIDE_EXPIRED: "override-expired",
    OVERRIDE_CLEAR_EXPIRED: "override-clear-expired",

    AUTHENTICATION_FAILED: "authenticatio-failed",

    //RunCompare
    STORE_FORM_A_RESTRICTION: "store-a-restriction",
    STORE_FORM_A_REQUEST: "store-b-request",
    STORE_FORM_B_RESTRICTION: "store-b-restriction",
    STORE_FORM_B_REQUEST: "store-b-request",
    RUNCOMPARE_CLICKED: "runcompare-clicked",
    RUNCOMPARE_CLICKED_SCHEMATIC: "runcompare-clicked-schematic",
    RUNCOMPARE_CALCULATED_GUIDS: "runcompare-calculated",
    GET_RUNCOMPARE: "get-runcompare",
    CLOSE_COMPARE_RESULTS: "close-compare-results",
    GET_UPDATE: "get-update",
    GET_RUNCOMPARE_CLICKED: "get-update-clicked",
    COMPARE_ITEMS_SAVED: "compare-items-saved",

    FORMC_CONTENT_CHANGED: "formc_content_changed",
    CHANGED_SELECT_ALL_SUB: "formc_select_all_sub",
    CHANGED_SELECT_ENTIRE_SUB: "formc_select_entire_sub",
    FORMC_CONTENT_CLEAN: "formc_content_clean",
  },

  RestrictionTypes: {
    A: "A",
    B: "B",
    C: "C",
    TCM: "TCM",
    RECENT: "RECENT",
  },

  RejectReasonType: {
    FORMA_REJECT: "AReject",
    FORMB_REJECT: "BReject",
  },

  RestrictionStatuses: {
    ISSUED: "restriction",
    REQUESTED: "request",
    VOIDED: "voided",
    REJECTED: "rejected",
    DELETED: "deleted",
    VERBAL: "verbal",
  },

  RequestListTypes: {
    HISTORY: "history",
  },

  Roles: {
    FIELD_SLODT: "slodt",
    FIELD_USER: "field user",
    FIELD_USER_A: "requestA",
    FIELD_USER_B: "requestB",
    FIELD_USER_C: "requestC",
    DISPATCHER: "dispatcher",
    READ_ONLY: "read-only",
    ADMIN: "admin",
    SUPER_USER: "superuser",
    OVERRIDE_ALLOWED: "grit-grant-override",
    SLS_USER: "grit-admin",
    FIELD_USER_ROLE: ["requestA", "requestB", "requestC"],
    DISPATCHER_ROLE: ["superuser", "admin", "dispatcher"],
  },

  Timezones: {
    E: "America/New_York",
    C: "America/Chicago",
    M: "America/Denver",
    P: "America/Los_Angeles",
    "": "America/Chicago", //assume central JIC
  },

  Tabs: {
    1: "A",
    2: "B",
    3: "history",
    4: "C",
    5: "TCM",
    6: "Recent",
    issuedFormA: "issuedFormA",
    requestFormA: "requestFormA",
    entryFormA: "entryFormA",
    issuedFormB: "issuedFormB",

    requestsFormB: "requestsFormB",
    entryFormB: "entryFormB",
    issuedFormC: "issuedFormC",
    entryFormC: "entryFormC",
    entryFormTCM: "entryFormTCM",
    issuedFormTCM: "issuedFormTCM",
    history: "historyTab",
    recentTab: "recentTab",
    unknown: "unknown",
  },

  recentHours: 16, //Sets how many hours in the past the recent tab should show

  BatchTypes: {
    ISSUE: "Issue",
    MODIFY: "Modify",
    VOID: "Void",
    APPROVE: "Approve",
    REJECT: "Reject",
  },

  Regex: {
    mpRegex: "^[0-9]{1,4}(\\.[0-9]{1}){0,1}$",
    suffixRegex: "^[a-zA-Z]{0,1}$",
    dateRegex: "^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])([0-9][0-9])$", //added year...
    timeRegex:
      "^(0[0-9][1-5][0-9]|0[0-9][0-5][1-9]|(0[1-9]|1[0-9]|2[0-3])[0-5][0-9])$",
    phoneRegex: "^([0-9]{3}-[0-9]{3}-[0-9]{4})$|^([0-9]{10})$",
    mpRegexNoDecimal: "^[0-9]{1,4}$",
    mpRegexNoLeadingDecimal: "^\\.[0-9]{1,4}$",
    subdivisionRegex: "[a-zA-Z]{2,6}",
    phoneRegexNoDash: "^([0-9]{10})$",
    speedRegex: "^(na|NA|Na|nA|[1-9]{1}[0-9]|[1-9])$",
    speedNARegex: "na|NA|Na|nA",
    userIdRegex: "[b,c,B,C][0-9]{6}",
  },

  Colors: {
    red: [255, 0, 0],
    green: [0, 255, 0],
    blue: [0, 0, 255],
    yellow: [255, 255, 0],
    cyan: [0, 255, 255],
    purple: [255, 0, 255],
    black: [255, 255, 255],
    white: [0, 0, 0],
  },

  RenderTypes: {
    normal: "Normal",
    other: "Other",
  },

  restrictionActions: {
    //the value is the name of the controller on the server!!!!!
    //FIELD ACTIONS
    SUBMIT_REQUEST: "submitRequest",
    UPDATE_REQUEST: "updateRequest",
    DELETE_REQUEST: "deleteRequest",
    SLODT_RESTRICTION: "updateSlowDateTime",
    FORMCDT_RESTRICTION: "updateFormCDateTime",
    TCMDT_RESTRICTION: "updateTCMDateTime",

    //DISPATCHER ACTIONS
    ISSUE_RESTRICTION: "issueRestriction",
    APPROVE_REQUEST: "approveRequest",
    APPROVE_REQUEST_TO_MODIFY: "approveRequestToModify",
    TRANSFER_REQUEST: "transferRequest",
    REJECT_REQUEST: "rejectRequest",
    VOID_RESTRICTION: "voidRestriction",
    MODIFY_RESTRICTION: "modifyRestriction",
    MODIFY_FORM_C_RESTRICTION: "modifyFormCRestriction",
    APPROVE_VERBAL_FORMA_RESTRICTION: "approveTemporary",
  },
  MaxValues: {
    MAX_COMMENT_LINE_LENGTH: 54,
    MAX_PATTERN_LINE_LENGTH: 62,
    MAX_TCM_LINE_LENGTH: 59,
    MAX_COMMENT_lINE_COUNT: 88,
    MAX_PATTERN_LINE_COUNT: 120,
    MAX_BORDERING_FLAG_COUNT: 10,
    POLL_MAX_TRIES: 60, //Poll the mainframe for a max of 60 seconds while GRIT waits for a reply
    POLL_RETRY_WAIT_PERIOD: 1000, //in ms
    OUTAGE_RETRY_WAIT_PERIOD: 1000 * 60 * 30, //ms (30 seconds for now)
  },
  fieldsThatRefreshSchematic: ["workStartMpSuffix", "workEndMpSuffix"],
  WebSocketConstants: {
    USER_OVERRIDE_GRANTED_QUEUE: "/user/queue/overrideGranted",
    USER_OVERRIDE_EXPIRED_QUEUE: "/user/queue/overrideExpired",
    USER_OVERRIDE_CHECK_QUEUE: "/user/queue/overrideCheck",
    USER_OUTAGE_BANNER_START_TIME_QUEUE: "/queue/bannerStartTime",
    USER_OUTAGE_START_TIME_QUEUE: "/queue/outageStartTime",
    USER_OUTAGE_END_TIME_QUEUE: "/queue/outageEndTime",
  },
  ValidationConstants: {
    NO_TRACK_FOUND: "No GUIDS available to verify with PTC. Please try again later.",
    UNDERPROTECT_ERROR_MESSAGE:
      "Your restriction MP range exceeds the *From: and/or *To: mileage of selected track by >0.1 miles. Please either adjust the *From: and/or *To: mileage of the restriction limits to be within 0.1 miles of the track’s MP range or select additional tracks to extend the restriction.",
  },
  UISubDivisions: {
    UI_LAKES_OLD: "LAKES",
    UI_LAKESI_OLD: "LAKESI",
    UI_LAKES_NEW: "LAKES (TWI)",
    UI_LAKESI_NEW: "LAKESI (NWE)",
  },
  ROUTE_AUTH_MESSAGES: {
    compare: "Compare",
    override: "Override",
    defaultTracks: "Default Tracks",
    gritUser: "Grit Users",
    reasonCodes: "Reason Code",
    gritItems: "Grit Items",
    subRecalculate: "SubReCalculate",
  },
};

export default Constants;
